import { Component, OnInit, ɵConsole } from '@angular/core';
import {Router} from  '@angular/router';
import { ConnectRestService } from 'src/app/services/connect-rest.service';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import {environment, countryCodes} from 'src/environments/environment.prod';
import { AppComponent } from '../app.component';
import { EnglishTranslation, MalayTranslation } from '../app.constants';
import { AppUtilityService } from 'src/app/common/app-utility.service';

// import {FormBuilder, FormGroup, FormArray} from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-business-detail',
  templateUrl: './business-detail.component.html',
  styleUrls: ['./business-detail.component.scss']
})
export class BusinessDetailComponent implements OnInit {

  
  BusinessDetails: FormGroup;
  
  constructor(
    public router: Router,
    private connect : ConnectRestService, 
    private formbuilder: FormBuilder,
    private AppUtility: AppUtilityService,
    public appComp: AppComponent
    ) { }
  BusinessDetailsOnLoad = true;
  ResponseBody:any;
  AddressInfo: FormArray;
  MainContactPerson: any;
  AddressDisplay:boolean=false;
  refSCDL: any;
  refCCDL: any;
  CountryCodes: any;
  countryCodes: any;
  ConnectedPersonsPL: any;
  Address: any;
  NewAddress: any;
  intialLoad: boolean = true;
  OnLoadDefaultAddress:any;
  CompanyInfo :any;
  textContent: any;
  
  
  BusinessDetailsCountryList = [{Code: "MY", Value: "Malaysia"}]
  

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.BusinessDetailsScreen : MalayTranslation.BusinessDetailsScreen;

    this.restConnect();
    this.BusinessDetails = this.formbuilder.group({
      CompanyInfo: this.formbuilder.group({
        AddressInfo: this.formbuilder.array([
          this.formbuilder.group({
          Address: [''],
          AddressLine1: [''],
          AddressLine2: [''],
          AddressLine3: [''],
          PostalCode: [''],
          StateCode: [''],
          CountryCode: [this.BusinessDetailsCountryList[0].Code]
        }),
        ]),
        MainContactPerson: ['', [Validators.required]],
      })
    })

    this.callDropdownValues().then(this.appComp.loadCustomDropdown);
 
  }

  validateChar(control){
    var value = control.value;
    if(!this.AppUtility.stringValidation(value)){
      control.setValue(this.AppUtility.filterInvalidCharacters(value));
    }
  }

  get addressArray() : FormArray{
      return this.BusinessDetails.get("CompanyInfo.AddressInfo") as FormArray
  }
/*
  get connectedPersonArray() : FormArray{
    return this.BusinessDetails.get("ConnectedPersonsPL") as FormArray
  }
*/
   async restConnect(){
    var serviceHeader = JSON.parse(sessionStorage.ServiceHeader)
    serviceHeader.Flow = "1"
    sessionStorage.ServiceHeader = JSON.stringify(serviceHeader)
    const RequestID = "R0030"
    var responseData = await this.connect.connectRest({},RequestID, '')

    responseData['CompanyInfo']['AddressInfo'][0].CountryCode = "MY"
    if(responseData['CompanyInfo']['AddressInfo'][0].Address = responseData['CompanyInfo']['AddressInfo'][0].Address) {
      responseData['CompanyInfo']['AddressInfo'][0].Address = responseData['CompanyInfo']['AddressInfo'][0].Address.toUpperCase();
    }
    if(responseData['CompanyInfo']['AddressInfo'][0].AddressLine1 = responseData['CompanyInfo']['AddressInfo'][0].AddressLine1) {
      responseData['CompanyInfo']['AddressInfo'][0].AddressLine1 = responseData['CompanyInfo']['AddressInfo'][0].AddressLine1.toUpperCase();
    }
    if(responseData['CompanyInfo']['AddressInfo'][0].AddressLine2 = responseData['CompanyInfo']['AddressInfo'][0].AddressLine2) {      
      responseData['CompanyInfo']['AddressInfo'][0].AddressLine2 = responseData['CompanyInfo']['AddressInfo'][0].AddressLine2.toUpperCase();
    }
    if( responseData['CompanyInfo']['AddressInfo'][0].AddressLine3 = responseData['CompanyInfo']['AddressInfo'][0].AddressLine3) {
      responseData['CompanyInfo']['AddressInfo'][0].AddressLine3 = responseData['CompanyInfo']['AddressInfo'][0].AddressLine3.toUpperCase();
    }

    this.AddressInfo = responseData['CompanyInfo']['AddressInfo'];

    if(responseData['CompanyInfo']['AddressInfo'][0].AddressLine1){
      this.intialLoad = false
    }else{
      this.OnLoadDefaultAddress = responseData['CompanyInfo']['AddressInfo'][0].Address;
    }
   
    this.ConnectedPersonsPL = responseData['ConnectedPersonsPL'];
    //this.Address = responseData.AddressInfo.Address;
    this.updateAddress(responseData)

    if (this.ConnectedPersonsPL && this.ConnectedPersonsPL.length == 1) {
      this.BusinessDetails.get('CompanyInfo.MainContactPerson').setValue(this.ConnectedPersonsPL[0].ID);
      this.BusinessDetails.get('CompanyInfo.MainContactPerson').updateValueAndValidity()
    }
  
  }

  onSuccessDataMapping(){

  }

  async callDropdownValues() {
    this.refSCDL = JSON.parse(sessionStorage.RefSCDL);
    this.refCCDL = JSON.parse(sessionStorage.RefCCDL);
    this.CountryCodes = countryCodes;
  }

  onDisplayaddress()
  {
    this.AddressDisplay = true;
    this.BusinessDetails.get('CompanyInfo.AddressInfo.0.AddressLine1').setValidators(Validators.required)
    this.BusinessDetails.get('CompanyInfo.AddressInfo.0.PostalCode').setValidators([Validators.required,Validators.minLength(5)])
  }


  onSubmit() {
    // this.updateAddress()
    // console.log("Business details" + JSON.stringify(this.BusinessDetails.value.CompanyInfo.AddressInfo[0].Address));
    this.updateMethod(this.BusinessDetails.value);   
  }

  public async updateMethod(data) {
    if(this.intialLoad == false || (data.CompanyInfo.AddressInfo[0].AddressLine1 && data.CompanyInfo.AddressInfo[0].AddressLine1.length>0)){
      data = this.newAddress(data)
    }else if(this.intialLoad == true || (data.CompanyInfo.AddressInfo[0].AddressLine1 && data.CompanyInfo.AddressInfo[0].AddressLine1.length>0)){
      delete data.CompanyInfo.AddressInfo[0]
      data.CompanyInfo.AddressInfo[0] = {Address: this.OnLoadDefaultAddress}
    }
    const RequestID = 'S0030';
    const responseData = await this.connect.connectRest(data, RequestID, '')
    if (responseData.Status === 'Success') {
    this.router.navigate(['/about-your-business']);
    }
  }

  newAddress(data) {
    //let form = this.BusinessDetails.value.AddressInfo[0]
    //this.data.AddressInfo[0].Address = form.AddressLine1 + this.data.AddressInfo[0].AddressLine2 + this.data.AddressInfo[0].AddressLine3 + this.data.AddressInfo[0].AddressLine4 + this.data.AddressInfo[0].PostalCode + this.data.AddressInfo[0].StateCode + this.data.AddressInfo[0].CountryCode;
  
    // data.CompanyInfo.AddressInfo[0].Address = data.CompanyInfo.AddressInfo[0].AddressLine1 + " " + data.CompanyInfo.AddressInfo[0].AddressLine2 + " " + data.CompanyInfo.AddressInfo[0].AddressLine3 + " " + data.CompanyInfo.AddressInfo[0].AddressLine4 + " " + data.CompanyInfo.AddressInfo[0].PostalCode + " " + data.CompanyInfo.AddressInfo[0].StateCode + " " + "Malaysia"
  
    // stateList.filter(state => {return state.Code ===data.CompanyInfo.AddressInfo})[0].Value;
  const stateList = JSON.parse(sessionStorage.RefSCDL);
    
  data.CompanyInfo.AddressInfo[0].Address = data.CompanyInfo.AddressInfo[0].AddressLine1 + " " + data.CompanyInfo.AddressInfo[0].AddressLine2 + " " + data.CompanyInfo.AddressInfo[0].AddressLine3 + " " + data.CompanyInfo.AddressInfo[0].PostalCode + " " + stateList.filter(state => {return state.Code ===data.CompanyInfo.AddressInfo[0].StateCode})[0].Value + " " + "Malaysia";
  
    return data
  }

  updateAddress(data) {
    delete data.ConnectedPersonsPL
    delete data.Status
    this.BusinessDetails.patchValue(data)   
    this.BusinessDetails.updateValueAndValidity()
  }
  
}
